module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-select-dropdown__item",
    class: {
      'selected': _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        'hover': _vm.parent.hoverIndex === _vm.index
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectOptionClick($event)
      }
    }
  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7af7d5ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/select/src/option.vue
// module id = 1145
// module chunks = 1